import * as React from 'react';
// note: indentity just echoes the same component back, its not related to "auth" identity.
export var AuthContext = React.createContext({
  isAvailable: false
});
export var AuthProvider = AuthContext.Provider;